export enum FileType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}

export enum BucketTypeCode {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
}
